// 企业版DNS（人工DNS）
export const ENTERPRICE_DNS = 'domain-gaojiban-DNS'
// 域名whois隐私保护
export const WHOIS = 'domain-server-whoisbaohu'
// 域名安全锁
export const DOMAIN_SECRURITY_LOCK = 'domain0007'
// 人工实名制
export const MANMADE_REALNAME = 'domain-server-shimingrenzeng'
// 人工过户
export const MANMADE_PASS_DOMAIN = 'domain-server-yumingguohu'
// 人工代办域名解析设置
export const MANMADE_DOMAIN_RESOLUTION = 'domain0006'
// 人工修改DNS
export const MANMADE_MODIFY_DNS = 'domain-server-DNSxiugai'


// WEBPACK FOOTER //
// ./static/scripts/product-id.const.js